import { loginRequest } from "authConfig";
import { isInteractionRequiredError } from "components/auth/interactionRequired";
import msalInstance from "../dev-auth";

class AuthTokenProvider {
  private redirectInitiated = false;

  async getAccessToken(ignoreCache: boolean = false): Promise<string | undefined> {
    const account = msalInstance.getActiveAccount();
    if (!account) {
      throw Error("No active account! Verify a user has been signed in and setActiveAccount has been called.");
    }

    try {
      const tokenResponse = await msalInstance.acquireTokenSilent({
        ...loginRequest,
        account: account,
        forceRefresh: ignoreCache,
      });

      return tokenResponse.accessToken;
    } catch (error) {
      if (!isInteractionRequiredError(error)) {
        throw error;
      }

      if (!this.redirectInitiated) {
        this.redirectInitiated = true;
        try {
          await msalInstance.acquireTokenRedirect({ ...loginRequest, account });
        } catch {
          // If acquireTokenRedirect itself fails (e.g. interaction already in progress),
          // let the in-flight redirect complete; reset so a later API call can retry.
          this.redirectInitiated = false;
        }
      }

      // Page is navigating to AAD. Never resolve so the caller (axios interceptor)
      // stays suspended until navigation tears down the JS context — surfacing the
      // original error here would re-introduce the auth-error flash on the page.
      return new Promise<never>(() => {});
    }
  }
}

export const authTokenProvider = new AuthTokenProvider();
